import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocLayoutComponent } from './layout/doc-layout/doc-layout.component';
import { MainComponent } from './content/pages/main/main.component';

const routes: Routes = [
  {
    path: '',
    component: DocLayoutComponent,
    children: [
      { path: '', component: MainComponent },
      { path: 'main', component: MainComponent },
      {
        path: 'getting-started',
        loadChildren: () =>
          import('./features/getting-started/getting-started.module').then(
            (m) => m.GettingStartedModule
          ),
      },
      {
        path: 'integration',
        loadChildren: () =>
          import('./features/integration/integration.module').then((m) => m.IntegrationModule),
      },
      {
        path: 'api',
        loadChildren: () =>
          import('./features/api/api-section.module').then((m) => m.ApiSectionModule),
      },
      { path: 'web-agoraweb-button', redirectTo: 'integration/web/agoraweb', pathMatch: 'full' },
      { path: 'web-cards-button', redirectTo: 'integration/web/cards', pathMatch: 'full' },
      { path: 'sdk-playground', redirectTo: 'integration/web/playground', pathMatch: 'full' },
      {
        path: 'flutter-agoraweb-button',
        redirectTo: 'integration/flutter/agoraweb',
        pathMatch: 'full',
      },
      { path: 'flutter-cards-button', redirectTo: 'integration/flutter/cards', pathMatch: 'full' },
      { path: 'api-orders', redirectTo: 'api/orders', pathMatch: 'full' },
      { path: 'api-operations', redirectTo: 'api/operations', pathMatch: 'full' },
      { path: 'api-events', redirectTo: 'api/events', pathMatch: 'full' },
      { path: 'api-payment', redirectTo: 'api/payment', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
